import React, { useState } from 'react';
import SearchComponent from './Search';
const NavBar = ({cond,setCond}) => {
  const [egg,setEgg]=useState(0)
  return (
    <header class="text-cusWhite font-poppins bg-cusDarkBlack">
      <div class="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
        <div class="flex title-font font-medium items-center text-gray-900 mb-4 md:mb-0" >
          <span class="ml-3 text-3xl text-cusOrange font-poppinsLight "><button onClick={(()=>{
            setEgg(egg+1)
          })}>ZAINO</button></span>
        </div>
        <nav class="md:ml-auto md:mr-auto flex flex-wrap items-center text-base justify-center invisible">

        </nav>

      {egg===3 &&  <SearchComponent cond={cond} setCond={setCond}/>} 

      </div>
    </header>
  )
}
export default NavBar;